
import { PostApi } from '@/api/PostApi';
import PostsListCard from '@/components/post/PostsListCard.vue';
import PublishPostCard from '@/components/post/PublishPostCard.vue';
import { ProjectViewMixin } from '@/mixins/ProjectViewMixin';
import { Post, Bot } from 'ignite360-core';
import { mixins } from 'vue-class-component';
import { Component, Watch } from 'vue-property-decorator';

@Component({
  name: 'project-content-posts',
  components: { PostsListCard, PublishPostCard },
})
export default class ProjectContentPosts extends mixins(ProjectViewMixin) {
  loadedPosts: Post[] = [];

  @Watch('bot', { immediate: true })
  async onBotChange(bot: Bot) {
    await this.loadPosts(bot);
  }

  async loadPosts(bot: Bot) {
    this.loadedPosts = await PostApi.loadBotPosts(bot.id);
  }
}
